import script from "./TrainerSessionDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerSessionDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./TrainerSessionDetailsPage.vue?vue&type=style&index=0&id=ddb2eaf8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddb2eaf8"]])

export default __exports__